import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69dc07c7a74957001427cc5c/hiretruckers365/src/app/legal/page.tsx");
